export namespace TestLevelsActions {
  export class SetAllTestLevels {
    static readonly type = '[TestLevels] SetAllTestLevels';
    constructor() {}
  }
}
